import { type ApiContainerAction, type ApiOrderPosition } from '@Model';
import { type Column, FlexRow } from '@synqo/frontend-component-library';
import { type ContainerActionKind } from './Containers/containerActionKind';
import tagStyles from './Containers/ContainerActionTag.module.css';
import { type PositionOrigin, positionOriginOf } from './positionOrigin';

const KIND: Record<PositionOrigin, ContainerActionKind> = {
    'aus Abholen': 'collect',
    'aus Leeren': 'empty',
    'aus Tausch': 'swap',
};

/** A column naming the container action each position's material comes from. */
// @ai-generated 2026-10-15T12:08:29+00:00 by malte.ulfers@tngtech.com using Claude Opus 5.5 (1M context)
export function positionOriginColumn(
    actions: readonly ApiContainerAction[],
    positions: readonly ApiOrderPosition[],
): Column<ApiOrderPosition> {
    return {
        name: 'origin',
        label: 'Herkunft',
        size: 130,
        disableColumnFilter: true,
        disableColumnSort: true,
        renderCell: ({ rowData }) => {
            const origin = positionOriginOf(rowData, positions, actions);

            return origin === undefined ? (
                <></>
            ) : (
                <FlexRow className={`${tagStyles.tag} ${tagStyles[KIND[origin]]}`} shrink={false}>
                    {origin}
                </FlexRow>
            );
        },
    };
}
